import React, { useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"; // Import Link for navigation
import '../css/Topbar.css'; // Import the CSS file for styling
import { AuthContext } from "../context/AuthContext"; // Import the AuthContext

const Topbar = () => {
    const navigate = useNavigate(); // Initialize the navigate function from React Router
    const { user, logoutLocal, refreshSession } = useContext(AuthContext); // Server-verified user

    // Handle login/logout button state
    const handleAuthAction = () => {
    if (user) {
            logout();
        } else {
            redirectToLogin();
        }
    };

    const redirectToLogin = () => {
        navigate("/login"); // Use navigate for routing
    };

    const logout = async () => {
        try {
            const response = await fetch("/api/logout", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
            });

            if (response.ok) {
                logoutLocal(); // Clear local user state
                navigate("/login"); // Redirect to login after logout
            } else {
                alert("Logout failed. Please try again.");
            }
        } catch (error) {
            console.error("Error during logout:", error);
            alert("An error occurred while logging out.");
        }
    };
    let location = useLocation();
    useEffect(() => {
        refreshSession();
    }, [refreshSession, location]);
    return (
        <div className="topbar">
            <Link to="/" className="title-name">LinkBMS Cloud</Link>
            <div className="topbar-buttons">
                {user && (
                    <div className="topbar-user" title={user.username}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="topbar-user-icon" aria-hidden="true" focusable="false">
                            {/* !Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
                            <path d="M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm-29.7 56C95.8 304 16 383.8 16 482.3 16 498.7 29.3 512 45.7 512l356.6 0c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3l-59.4 0z"/>
                        </svg>
                        <span className="topbar-username">{user.username}</span>
                    </div>
                )}
                <div className="topbar-button" onClick={handleAuthAction}>{user ? "Logout" : "Login"}</div>
            </div>
        </div>
    );
};

export default Topbar;
